import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import SectionHeading from '../components/ui/SectionHeading';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiCheck } from 'react-icons/fi';
import { servicesList } from '../data/content';

const Services = () => {
  return (
    <div className="bg-veloura-bg min-h-screen">
      <PageHeader title="Our Services" bgImage="https://images.unsplash.com/photo-1587905008064-0750ca8ab403?auto=format&fit=crop&q=80&w=2000" />
      
      <div className="container mx-auto px-6 max-w-5xl py-24">
        <SectionHeading title="Lash Menu" subtitle="Customized Artistry" />
        
        <div className="space-y-16">
          {servicesList.map((service, index) => (
            <div key={service.id} className={`flex flex-col ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} bg-white rounded-[2rem] overflow-hidden shadow-sm border border-veloura-primary/20`}>
              
              <div className="md:w-5/12 h-64 md:h-auto relative">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover" />
              </div>
              
              <div className="md:w-7/12 p-8 md:p-12 flex flex-col justify-center">
                <div className="flex flex-wrap justify-between items-baseline mb-4 gap-4">
                  <h3 className="font-serif text-3xl text-veloura-text">{service.title}</h3>
                  <span className="text-xl font-medium text-veloura-accent bg-veloura-primary/30 px-4 py-1 rounded-full">{service.price}</span>
                </div>
                
                <div className="flex items-center text-veloura-muted mb-6 text-sm">
                  <SafeIcon icon={FiClock} className="mr-2" /> 
                  <span>Duration: {service.duration}</span>
                </div>
                
                <p className="text-veloura-text text-lg mb-6 leading-relaxed">
                  {service.desc}
                </p>
                
                <div className="space-y-3 mb-8 bg-veloura-bg rounded-xl p-6">
                  <div className="flex items-start">
                    <SafeIcon icon={FiCheck} className="text-veloura-accent mt-1 mr-3 shrink-0" />
                    <div>
                      <strong className="block text-sm text-veloura-text uppercase tracking-wider mb-1">Best For:</strong>
                      <span className="text-veloura-muted text-sm">{service.bestFor}</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <SafeIcon icon={FiCheck} className="text-veloura-accent mt-1 mr-3 shrink-0" />
                    <div>
                      <strong className="block text-sm text-veloura-text uppercase tracking-wider mb-1">Maintenance:</strong>
                      <span className="text-veloura-muted text-sm">{service.maintenance}</span>
                    </div>
                  </div>
                </div>
                
                <div>
                  <Button to="/book" variant="outline">Book This Service</Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;